module.exports = __webpack_public_path__ + "img/menuleft.e9b783c3.png";